var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.411,
    height: 24.411,
    viewBox: "0 0 24.411 24.411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.086,10.5H13.908V1.326A1.646,1.646,0,0,0,12.205,0a1.646,1.646,0,0,0-1.7,1.325V10.5H1.325A1.646,1.646,0,0,0,0,12.206a1.646,1.646,0,0,0,1.325,1.7H10.5v9.178a1.646,1.646,0,0,0,1.7,1.325,1.646,1.646,0,0,0,1.7-1.325V13.909h9.178a1.646,1.646,0,0,0,1.325-1.7A1.646,1.646,0,0,0,23.086,10.5Z",
    transform: "translate(0 -0.001)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.a72ccbe2.svg";
export { ForwardRef as ReactComponent };